var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnrichCompanyTick = function SvgEnrichCompanyTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3a.9.9 0 0 1 .9.9V9h-1.8V4.8H5.7v14.4h14.4V21h-18v-1.8h1.8V3.9a.9.9 0 0 1 .9-.9zm-8.1 13.5H8.4v-1.8h2.7zm0-3.6H8.4v-1.8h2.7zm0-3.6H8.4V7.5h2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.118 13.545 3.182 3.183 4.455-4.455L21.482 11 18.3 14.182l-1.909-1.91z"
  })));
};
export default SvgEnrichCompanyTick;